import { render, staticRenderFns } from "./ElementDropZone.vue?vue&type=template&id=541f436e&scoped=true&"
import script from "./ElementDropZone.vue?vue&type=script&lang=ts&"
export * from "./ElementDropZone.vue?vue&type=script&lang=ts&"
import style0 from "./ElementDropZone.vue?vue&type=style&index=0&id=541f436e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f436e",
  null
  
)

export default component.exports